import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '@app/core/services/user.service';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * Simple Welcome Login Page
 */
@Component({
  selector: 'app-auth-login',
  imports: [
    TranslatePipe
  ],
  templateUrl: './auth-login.component.html',
  styleUrl: './auth-login.component.css'
})
export class AuthLoginComponent implements OnInit {
  constructor(
    private readonly route: ActivatedRoute,
    private readonly userService: UserService,
  ) {}

  public ngOnInit(): void {
    const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') ?? '/';
    this.userService.login(returnUrl);
  }
}
